module.exports = __webpack_public_path__ + "static/media/mira_appstore_screens.f592ec22.png";